<script setup>
import { computed } from 'vue';
import { trans } from "@/Utils/translation.utils.js";

const props = defineProps({
    rating: {
        type: Number,
        default: 0
    },
    reviewsCount: {
        type: Number,
        default: 0
    },
    linkToReviews: {
        type: String,
        default: '#reviews-cover'
    }
});

const ratingPercentage = computed(() => {
    return (props.rating / 5) * 100;
});
</script>

<template>
    <div class="service-card__reviews" v-if="reviewsCount > 0">
        <div class="star-rating">
            <div class="star-rating__stars">
                <div class="stars-outer">
                    <div class="stars-inner" :style="{ width: `${ratingPercentage}%` }"></div>
                </div>
            </div>
            <div class="service-card__reviews-text">
                {{ reviewsCount }}+ {{ trans('reviews.verified') }}
                <a :href="linkToReviews">{{ trans('reviews.customer_reviews') }}</a>
            </div>
        </div>
    </div>
</template>
